import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["page", "prevButton", "nextButton"];

  connect() {
    this.currentPage = 0;
    this.totalPages = this.pageTargets.length;
    this.updatePageVisibility();
  }

  next() {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.updatePageVisibility();
    }
  }

  prev() {
    if (this.currentPage === 0) {
      window.HSOverlay.close("#modal-stationery_onboarding_details");
      window.HSOverlay.open("#modal-stationery_onboarding");
    } else if (this.currentPage > 0) {
      this.currentPage--;
      this.updatePageVisibility();
    }
  }

  updatePageVisibility() {
    this.pageTargets.forEach((page, index) => {
      this.toggleElementVisibility(page, index === this.currentPage);
    });

    if (this.hasPrevButtonTarget) {
      this.toggleElementVisibility(this.prevButtonTarget, true);
    }

    if (this.hasNextButtonTarget) {
      this.toggleElementVisibility(this.nextButtonTarget, this.currentPage < this.totalPages - 1);
    }
  }

  toggleElementVisibility(element, isVisible) {
    if (isVisible) {
      element.classList.remove("hidden");
    } else {
      element.classList.add("hidden");
    }
  }
}

